import { CarouselItem } from '@app/ui-components/carousel/types';

export const DP_NEWS_LIST_FEATURE = 'dpNewsListFeature';

export type NewsListState = {
  cursor: number;
  rowCount: number;
  newsList: CarouselItem[];
};
